import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const TriangleIcon: React.FC<SvgIconProps> = (props) => {
  const size = 100;
  const h = Math.sqrt(3) * size / 2;

  return (
    <SvgIcon {...props} viewBox={`0 0 ${size} ${h}`}>
      <path d={`M${size / 2} 0L${size} ${h}H0L${size / 2} 0z`} />
    </SvgIcon>
  );
};

export default TriangleIcon;
